module.exports = __webpack_public_path__ + "static/russell-brand-52366123f3eeafce6a5b2ece183969cf.jpg";